export const contactName = (contact, fallback = '-') => {
    const clean = value => value == null || /^(null|undefined)$/i.test(String(value).trim()) ? '' : String(value).trim();
    return clean(contact?.title) || [clean(contact?.name), clean(contact?.surname)].filter(Boolean).join(' ') || fallback;
};
